import { graphql } from 'gatsby';
import { createGatsbyPageComponent } from '@shapeable/ui';
export default createGatsbyPageComponent('Page');

export const QUERY = graphql`
query PageQuery($id: ID!) {
  platform { page(id: $id) {
    id name slug typeLabel badge path updated __typename _schema { label pluralLabel }  
    title 
    pretitle
    subtitle
    titleRich { text }
    subtitleRich { text }
    published
    content { text }
    options { text }
    themeMode { slug }
    bannerThemeMode { slug }
    openGraph { title description { plain } image { url url2x thumbnails { card { url url2x } bubble { url url2x } } } }
    intro { plain text }
    outro { text }
    orderNumber
    layout {
      id name slug component 
    }
    videos {
      id name url
      thumbnail { id url url2x }
    }
    imageAssets {
      id name image { id url url2x type }
    }
    people {
      id name slug path
      organisation { id name }
      linkedin
      position
      photo { id url url2x thumbnails { bubble { url url2x } } type }
    }
    embeds {
      citations {
        slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
      }
      pages {
        id name slug path
        openGraph {
          title description { plain }
          image { url url2x thumbnails { bubble { url url2x } } type }
        }
      }
      people {
        id name slug path
        organisation { id name }
        position
        photo { id url }
      }
      imageAssets {
        id
        slug
        image {
          id url url2x type width height 
        }
      }
    }
    
    parent {
      __typename id name path slug title subtitle pretitle 
      content { text }
      children {
        __typename id name path slug title subtitle pretitle 
        openGraph { description { text } }
        intro { text }
        orderNumber
        banner {
          name slug alternateText
          thumbnail { 
            id url width height 
          }
        }
      }
    }
    children {
      __typename id name path slug title subtitle pretitle 
      openGraph { description { text } }
      intro { text }
      orderNumber
      banner {
        name slug alternateText
        thumbnail { 
          id url width height 
        }
      }
    }
    banners {
      id name slug title description { text } alternateText
      image { 
        id url type width height
      }
    }
    slices {
      id name slug 
      title
      disabled
      created updated
      outro { text }
      intro { text }
      themeMode { slug }
      images {
        id name slug alternateText description { text }
        image { 
          id url type width height
        }
      }
      pages {
        id name path disabled
      }
      people {
        __typename
        id name slug 
        photo { url url2x type grayscale { id url url2x } }
        position
        bio { text html(links: { target: "_blank" }) }
        linkedin
        organisation { id name }
      }
      links {
        id name url label __typename _schema { label pluralLabel } 
        page { path }
        image { url url2x thumbnails { card { url url2x } } }
        description { text }
        openGraph { image { url url2x thumbnails { card { url url2x } } } }
        color { id value }
      }
      options { text }
      files {
        id
        name
        slug
        file {
          id
          url
        }
        thumbnail {
          url
        }
      }
      videos { 
        url 
        openGraph {
          image { url url2x type thumbnails { card { url url2x } } }
        }
      }
      color { value }
      backgroundColor { value }
      backgroundImages {
        image {
          url
        }
      }
      blocks {
        id name slug __typename
        pretitle
        title 
        titleRich { id text }
        subtitle
        links { id name slug label isDownload url page { path } type { id name } file { file { url } } }
        page { id path name }
        links { id url name }
        pages { id name }
        content { id text }
        options { id text }
        color { value }
        backgroundColor { value }
        icon { openGraph { image { id type width height url url2x } } }
        image { 
          id 
          image {
            url url2x type width height thumbnails { card { url url2x } halfBanner { url url2x } mainBanner { url url2x } } 
          }
        }
      }
      content { text }
      image { id }
      layout { id name slug component }
      organisations {
        id
        name
        url
        logoInverted { type url }
        logo { type url }
      }
    }
  } }
}
`;
